<template>
  <div style="display: inline-block">
    <v-btn
      v-if="livechat"
      @click.stop="openModal"
      color="primary"
      outline
      fab
      :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
      small
    >
      <v-icon>edit</v-icon>
    </v-btn>
    <v-btn
      v-if="type == 'add'"
      @click="openModal"
      color="primary"
      outline
      :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
      ><v-icon>add</v-icon>Add</v-btn
    >
    <v-dialog persistent v-model="showManage" max-width="600">
      <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup">
        <v-layout>
          <v-flex class="pl-4 pt-3">
            <h3 class="title">{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn small fab flat @click="onCancel" :loading="loading || loadingTicket">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <div class="text-xs-right">
            <v-autocomplete
              return-object
              label="Find customer"
              solo
              v-model="select"
              :loading="loading"
              :items="items"
              :search-input.sync="search"
              cache-items
              outline
              prepend-inner-icon="search"
              :item-text="'first_name'"
              :item-value="'id'"
              @change="onChangeSelect"
            >
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar>
                    <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                    <img v-else :src="'/static/img/assets/livechat/profile.png'" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="data.item.first_name + ' ' + data.item.last_name"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.app"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>

              <template v-slot:append-outer>
                <v-icon
                  :key="`icon-delete`"
                  :disabled="!select"
                  @click="onClearCustomer"
                  v-text="'delete'"
                ></v-icon>
              </template>
            </v-autocomplete>
          </div>
          <v-layout wrap>
            <template v-if="!livechat">
              <v-flex
                xs12
                sm6
                class="form-control px-1"
                :class="{ 'has-error': errors.has('firstname') }"
              >
                <div class="caption mb-1 mt-2">Customer First Name *</div>
                <div
                  class="primary--text mb-3"
                  v-if="['facebook', 'line'].includes(ticket.channel)"
                >
                  {{ ticket.firstname }}
                </div>
                <template v-else>
                  <input
                    type="text"
                    :placeholder="$t('customer first name')"
                    v-model="ticket.firstname"
                    class="form-control"
                    maxlength="255"
                    v-validate="'required'"
                    :data-vv-as="$t('Customer First Name')"
                    name="firstname"
                  />
                </template>
                <p class="text-error" v-if="errors.has('firstname')">
                  {{ errors.first('firstname') }}
                </p>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Customer Last Name</div>
                <div
                  class="primary--text mb-3"
                  v-if="['facebook', 'line'].includes(ticket.channel)"
                >
                  {{ ticket.lastname }}
                </div>
                <template v-else>
                  <input
                    type="text"
                    :placeholder="$t('customer last name')"
                    v-model="ticket.lastname"
                    class="form-control"
                    maxlength="255"
                  />
                </template>
              </v-flex>

              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Gender</div>
                <multiselect
                  v-model="ticket.gender"
                  :options="genderOptions"
                  :searchable="false"
                  :allow-empty="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Email</div>
                <input
                  type="text"
                  :placeholder="$t('Email')"
                  v-model="ticket.email"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">Phone No</div>
                <input
                  type="number"
                  :placeholder="$t('Phone No')"
                  v-model="ticket.phoneno"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1">
                <div class="caption mb-1 mt-2">App</div>
                <div class="primary--text mb-3" v-if="ticket.userid">
                  {{ ticket.app }}
                </div>
                <multiselect
                  v-else
                  class="mb-3"
                  v-model="ticket.app"
                  :key="`app`"
                  :options="appOptions"
                  selectLabel
                  selectedLabel
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="form-control px-1">
                <div class="caption mb-1 mt-2">Address</div>
                <textarea
                  name="address"
                  id="address"
                  style="width: 100%; min-height: 100px"
                  :data-vv-as="$t('Address')"
                  class="form-control"
                  v-model="ticket.address"
                  :placeholder="$t('Address')"
                ></textarea>
              </v-flex>
              <v-flex xs12>
                <v-divider class="my-3" />
              </v-flex>
            </template>
            <template v-if="$store.state.privilege && $store.state.privilege.assign_ticket">
              <v-flex
                xs12
                sm6
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('group') }"
              >
                <div class="caption mb-1 mt-2">Group *</div>
                <multiselect
                  v-model="ticket.group"
                  :options="agentGroup"
                  track-by="groupname"
                  label="groupname"
                  :searchable="true"
                  selectLabel
                  selectedLabel
                  deselect-label
                  @input="onChangeGroup"
                  v-validate="'required'"
                  :data-vv-as="$t('Group')"
                  name="group"
                ></multiselect>
                <p class="text-error" v-if="errors.has('group')">{{ errors.first('group') }}</p>
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Subgroup</div>
                <v-layout>
                  <multiselect
                    v-model="ticket.subgroup"
                    :options="filterSubGroup"
                    track-by="subgroupname"
                    label="subgroupname"
                    :searchable="true"
                    selectLabel
                    selectedLabel
                    @input="onChangeSubGroup"
                    deselect-label
                  ></multiselect>

                  <v-btn
                    small
                    flat
                    fab
                    class="my-0"
                    @click="
                      ticket.subgroup = null
                      ticket.assignedTo = null
                    "
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 class="form-control px-1 pb-2">
                <div class="caption mb-1 mt-2">Assigned to</div>
                <v-layout>
                  <multiselect
                    v-model="ticket.assignedTo"
                    :options="filterAgents"
                    @input="onAssignInput"
                    track-by="name"
                    label="name"
                    :searchable="true"
                    selectLabel
                    selectedLabel
                    deselect-label
                  ></multiselect>

                  <v-btn small flat fab class="my-0" @click="ticket.assignedTo = null">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.group">
                <div class="caption mb-1 mt-2">Group *</div>
                {{ ticket.group.groupname }}
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.subgroup">
                <div class="caption mb-1 mt-2">Subgroup</div>
                {{ ticket.subgroup.subgroupname }}
              </v-flex>
              <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.assignedTo">
                <div class="caption mb-1 mt-2">Assigned to</div>
                {{ ticket.assignedTo.name }}
              </v-flex>
            </template>

            <v-flex
              xs12
              class="form-control px-1"
              :class="{ 'has-error': errors.has('Type of Inquiry_LOC') }"
            >
              <div class="caption mb-1 mt-2">Type of Inquiry_LOC *</div>
              <input
                type="text"
                :placeholder="$t('Type of Inquiry_LOC')"
                v-model="ticket.subject"
                class="form-control"
                maxlength="255"
                v-validate="'required'"
                :data-vv-as="$t('Type of Inquiry_LOC')"
                name="Type of Inquiry_LOC"
              />
              <p class="text-error" v-if="errors.has('Type of Inquiry_LOC')">
                {{ errors.first('Type of Inquiry_LOC') }}
              </p>
            </v-flex>
            <v-flex xs12 class="form-control px-1" :class="{ 'has-error': errors.has('details') }">
              <div class="caption mb-1 mt-2">Internal note/Other Question/Comment/Note *</div>
              <textarea
                name="details"
                id="details"
                style="width: 100%; min-height: 100px"
                :data-vv-as="$t('Details')"
                class="form-control"
                v-model="ticket.details"
                :placeholder="$t('Details')"
                v-validate="'required'"
              ></textarea>
              <p class="text-error" v-if="errors.has('details')">{{ errors.first('details') }}</p>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Name</div>
              <template>
                <input
                  type="text"
                  :placeholder="$t('Name')"
                  v-model="ticket.contact_firstname"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Surname</div>

              <template>
                <input
                  type="text"
                  :placeholder="$t('Surname')"
                  v-model="ticket.contact_lastname"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">ID (Last 4 digits)</div>
              <template>
                <input
                  type="text"
                  :placeholder="$t('0000')"
                  v-model="ticket.contact_salary"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex>
            <!-- <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Occupation</div>
              <template>
                <input
                  type="text"
                  :placeholder="$t('Occupation')"
                  v-model="ticket.contact_occupation"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex> -->
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Phone</div>
              <template>
                <input
                  type="number"
                  :placeholder="$t('Phone')"
                  v-model="ticket.contact_phone"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6 class="form-control px-1">
              <div class="caption mb-1 mt-2">Product Name</div>
              <template>
                <input
                  type="text"
                  :placeholder="$t('Product Name')"
                  v-model="ticket.contact_email"
                  class="form-control"
                  maxlength="255"
                />
              </template>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption mb-1 mt-2">Type *</div>
              <multiselect
                class="mb-3"
                v-model="priority"
                :key="`priority`"
                :options="priorityOptions"
                label="text"
                selectLabel
                selectedLabel
                :allow-empty="false"
                :searchable="false"
                deselect-label
                track-by="text"
              ></multiselect>
            </v-flex>

            <v-flex
              xs12
              sm6
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('status') }"
            >
              <div class="caption mb-1 mt-2">Status *</div>
              <multiselect
                v-model="ticket.status"
                :options="statusOptions"
                :searchable="false"
                :allow-empty="false"
                selectLabel
                selectedLabel
                deselect-label
                v-validate="'required'"
                :data-vv-as="$t('Status')"
                name="status"
              ></multiselect>
              <p class="text-error" v-if="errors.has('status')">{{ errors.first('status') }}</p>
            </v-flex>

            <v-flex
              xs12
              class="form-control px-1 pb-2"
              :class="{ 'has-error': errors.has('channel') }"
            >
              <div class="caption mb-1 mt-2">Channel *</div>

              <v-radio-group
                v-model="ticket.channel"
                d-inline
                row
                v-validate="'required'"
                :data-vv-as="$t('Channel')"
                name="channel"
              >
                <v-radio
                  class="mb-2"
                  :value="'facebook'"
                  color="primary"
                  label="facebook"
                ></v-radio>
                <v-radio class="mb-2" :value="'line'" color="primary" label="line"></v-radio>
                <v-radio class="mb-2" :value="'phone'" color="primary" label="phone"></v-radio>
                <v-radio class="mb-2" :value="'email'" color="primary" label="email"></v-radio>
                <v-radio class="mb-2" :value="'website'" color="primary" label="website"></v-radio>
                <v-radio class="mb-2" :value="'others'" color="primary" label="others"></v-radio>
              </v-radio-group>
              <p class="text-error" v-if="errors.has('channel')">{{ errors.first('channel') }}</p>
            </v-flex>

            <v-flex xs12>
              <div class="caption mb-1 mt-2">Question_LOC</div>
              <v-combobox
                v-model="tags"
                :filter="tagsfilter"
                :hide-no-data="!tagssearch"
                :items="tagitems"
                :search-input.sync="tagssearch"
                hide-selected
                label="Search for an option"
                multiple
                small-chips
                solo
              >
                <template v-slot:no-data>
                  <v-list-tile>
                    <span class="subheading">Create</span>
                    <v-chip :color="`primary lighten-3`" label small>{{ tagssearch }}</v-chip>
                  </v-list-tile>
                </template>
                <template v-slot:selection="{ item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    :color="`primary lighten-3`"
                    :selected="selected"
                    label
                    small
                  >
                    <span class="pr-2">{{ item.text }}</span>
                    <v-icon small @click="parent.selectItem(item)">close</v-icon>
                  </v-chip>
                </template>
                <template v-slot:item="{ index, item }">
                  <v-list-tile-content>
                    <v-text-field
                      v-if="tagediting === item"
                      v-model="tagediting.text"
                      autofocus
                      flat
                      background-color="transparent"
                      hide-details
                      solo
                      @keyup.enter="tagsedit(index, item)"
                    ></v-text-field>
                    <v-chip v-else :color="`primary lighten-3`" label small>{{ item.text }}</v-chip>
                  </v-list-tile-content>
                  <v-spacer></v-spacer>
                  <v-list-tile-action @click.stop>
                    <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                      <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
              </v-combobox>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs7 class="px-1 form-control">
              <div class="caption">Due Date</div>
              <datepicker
                color="primary"
                v-model="duedate.start"
                @selected="onSelectedDueDate"
              ></datepicker>
            </v-flex>
            <v-flex xs4 class="px-1 form-control">
              <div class="caption">Time</div>

              <v-dialog
                ref="starttime"
                v-model="showDueTimeDialog"
                :return-value.sync="duedate.starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-layout>
                    <input
                      type="text"
                      readonly
                      v-on="on"
                      placeholder="00:00"
                      v-model="duedate.starttime"
                      :disabled="duedate.start == null"
                    />
                  </v-layout>
                </template>
                <v-time-picker v-if="showDueTimeDialog" v-model="duedate.starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showDueTimeDialog = false">{{
                    $t('cancel')
                  }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(duedate.starttime)
                      showDueTimeDialog = false
                      onSelectedDueDate(duedate.end)
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs1>
              <div class="caption">&nbsp;</div>
              <v-btn
                fab
                flat
                small
                @click="
                  duedate.starttime = null
                  duedate.start = null
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <v-btn outline color="grey" @click="onCancel" :loading="loading || loadingTicket">
              {{ $t('cancel') }}
            </v-btn>
            <template v-if="$store.state.privilege && $store.state.privilege.update_ticket">
              <v-btn
                color="primary"
                depressed
                @click="onSave"
                :loading="loading || loadingTicket"
                >{{ $t('Save') }}</v-btn
              >
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageTicket from './ManageTicket.js'
export default {
  mixins: [ManageTicket],
  data() {
    return {
      priorityOptions: [
        {
          text: 'Question',
          value: 'low'
        },
        {
          text: 'Problem',
          value: 'medium'
        },
        {
          text: 'Incident',
          value: 'high'
        }
      ],
      priority: {
        text: 'Problem',
        value: 'medium'
      }
    }
  },
  mounted() {
    this.$validator.pause()
    this.$nextTick(() => {
      this.$validator.errors.clear()
      this.$validator.fields.items.forEach((field) => field.reset())
      this.$validator.fields.items.forEach((field) => this.errors.remove(field))
      this.$validator.resume()
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/EditTicketMonix.vue